import * as React from 'react'
import { inject, observer } from 'mobx-react'
import { CurrentCompanyStore } from '../../../stores/CurrentCompanyStore'
import { CurrentUserStore } from '../../../stores/CurrentUserStore'
import { AppView, AppViewWrapper } from '../../../components/AppView'
import { NoPermissionsResult } from '../../../components/NoPermissionsResult'
import Helmet from 'react-helmet'
import { PermissionNames } from '@getgreenline/homi-shared'

interface StoreProps {
  currentCompanyStore?: CurrentCompanyStore
  currentUserStore?: CurrentUserStore
}

@inject('currentCompanyStore', 'currentUserStore')
@observer
export class DashboardEmployeeRoot extends React.Component<
  React.PropsWithChildren<StoreProps>,
  {}
> {
  company = this.props.currentCompanyStore!.company!

  render() {
    if (
      !this.props.currentUserStore!.hasPermissionAtEntity(
        PermissionNames.CAN_MANAGE_EMPLOYEES,
        this.company.id,
      )
    ) {
      return <NoPermissionsResult permissionName={PermissionNames.CAN_MANAGE_EMPLOYEES} />
    }

    return (
      <AppView>
        <Helmet>
          <title>Employees | Employee List</title>
          <meta name='page-loaded' content='true' />
        </Helmet>
        <AppViewWrapper>{this.props.children}</AppViewWrapper>
      </AppView>
    )
  }
}
